module.exports = __webpack_public_path__ + "img/nav04.9ce5d10e.png";